import { Button, Card, Col, Descriptions, Input, message, Modal, Row, Typography } from 'antd';
import React, { useState } from 'react'
import Post from '../services/Post';

const PUCCheck = () => {
    const [vehicle, setVehicle] = useState();
    const [details, setDetails] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {

            if (!vehicle) {
                message.error('Please enter a vehicle registration number');
                setLoading(false)
                return;
            }

            console.log("serach value = ", vehicle);

            const response = await Post.CheckPuc(vehicle);
            console.log("Response data:", response);

            if (response && response.data) {
                const items = [
                    {
                        label: 'Registration No.',
                        value: response.data.regNo,
                    },
                    {
                        label: 'Month & Year of Manufacturing',
                        value: response.data.manufacturedMonthYear,
                    },
                    {
                        label: 'Fuel Type',
                        value: response.data.fuelType,
                    },
                    {
                        label: 'Norms',
                        value: response.data.fuelNorms,
                    },
                    {
                        label: 'PUC Number',
                        value: response.data.pucNo,
                    },
                    {
                        label: 'Validity Upto',
                        value: response.data.pucUpto,
                    }
                ];
                setDetails(items);
                setModalVisible(true);
            } else {
                message.error(response.error);
            }
        } catch (error) {
            console.error('Error:', error);
            message.error('An error occurred while processing your request');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Row justify={'center'}>
                <Col xs={24} xl={8} md={12}>
                    <Card style={{ padding: 10 }}>
                        <Typography.Title level={5}>Enter Vehicle Number</Typography.Title>
                        <Input
                            placeholder="Enter Vehicle Number"
                            type="text"
                            width={'100%'}
                            style={{ marginBottom: 30 }}
                            onChange={(e) => setVehicle(e.target.value)}
                        />
                        <Button
                            className='form-btn'
                            type='primary'
                            style={{
                                backgroundColor: "#a6cc43",
                                borderColor: "#a6cc43",
                            }}
                            block
                            onClick={handleSubmit}
                            loading={loading}
                        >
                            Submit
                        </Button>
                    </Card>
                </Col>
                <Modal
                    title="PUC Details"
                    open={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    footer={null}
                >
                    <Descriptions layout='vertical'>
                        {details.map((detail, index) => (
                            <Descriptions.Item key={index} label={detail.label} span={2}>
                                {detail.value}
                            </Descriptions.Item>
                        ))}
                    </Descriptions>
                </Modal>
            </Row>
        </div>
    )
}

export default PUCCheck